import { PopUpData } from '../../types';

// Custom Pop Ups should have a "PopupId" of type 'string'
// Custom Pop Ups will show up in Admin CMS, but will not be editable
export const customPopUps: PopUpData[] = [];
